<template>
	<div class="introduce">
		<div class="content">
			<div class="title flex-column">
				<div class="">医药营销合规管理云系统——药销通</div>
				<div class="">实现精细化、合规化、费控化多级管理合规升级</div>
			</div>
			<div class="">
				<div class="titleList flex-row" :class="isFixed == true ? 'isFixed' : ''">
					<div class="item flex-column" v-for="(item, index) in list" :key="index" @click="change(index)">
						<div :class="activeBar == index ? 'active-item' : ''">{{ item.title }}</div>
						<div class="bar" :class="activeBar == index ? 'active-bar' : ''"></div>
					</div>
				</div>
				<div class="bottom">
					<div v-if="activeBar == 0">
						<!-- <div class="subTitle">{{ list[activeBar].subTitle }}</div> -->
						<div class="appealContent flex-column">
							<div class="item item1">
								<div class="image flex-row flex-center"><img :src="list[activeBar].compliance1" alt="" /></div>
								<div class="text">{{ list[activeBar].textList[0] }}</div>
							</div>
							<div class="item item2">
								<div class="image flex-row flex-center"><img :src="list[activeBar].compliance2" alt="" /></div>
								<div class="text">{{ list[activeBar].textList[1] }}</div>
							</div>
							<div class="item item3">
								<div class="image flex-row flex-center"><img :src="list[activeBar].compliance3" alt="" /></div>
								<div class="text">{{ list[activeBar].textList[2] }}</div>
							</div>
						</div>
					</div>
					<div v-if="activeBar == 1">
						<!-- <div class="subTitle">{{ list[activeBar].subTitle }}</div> -->
						<div class="shell">
							<div @click="prev1" class="cursor arrow-left arrow"><i class="el-icon-arrow-left"></i></div>
							<div @click="next1" class="cursor arrow-right arrow"><i class="el-icon-arrow-right"></i></div>
							<el-carousel ref="carouse1" arrow="never" height="924px" trigger="click">
								<el-carousel-item v-for="(item, index) in functionList" :key="index">
									<div class=" function flex-row">
										<div class="left flex-row flex-center"><img :src="item.imgUrl" alt="" /></div>
										<div class="right">
											<div class="subTitle2">{{ item.subTitle }}</div>
											<div class="content2 flex-row" v-for="(item, index) in item.textList" :key="item">
												<div class="dot"></div>
												<div class="text">{{ item }}</div>
											</div>
											<div class="button flex-row">
												<div @click="toOpen" class="button1 cursor"><el-button>立即体验</el-button></div>
												<!-- <div @click="kefu" class="chat-btn button2 cursor"><el-button>在线咨询</el-button></div> -->
											</div>
										</div>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>
					</div>
					<div v-if="activeBar == 2">
						<!-- <div class="subTitle">{{ list[activeBar].subTitle }}</div> -->
						<div class="shell">
							<div @click="prev2" class="cursor arrow-left arrow"><i class="el-icon-arrow-left"></i></div>
							<div @click="next2" class="cursor arrow-right arrow"><i class="el-icon-arrow-right"></i></div>
							<el-carousel ref="carouse2" arrow="never" height="924px" trigger="click">
								<el-carousel-item v-for="(item, index) in Math.ceil(advantageList.length / 6)" :key="index">
									<div class="advantage flex-row">
										<div class="list">
											<div class="item" v-for="(item, index2) in advantageList.slice(index == 0 ? 0 : 6, index == 0 ? 6 : 9)">
												<div class="line1 flex-row">
													<div class="img flex-row flex-center"><img :src="item.IconUrl" alt="" /></div>
													<div class="subTitle2">{{ item.subTitle }}</div>
												</div>
												<div class="text">{{ item.text }}</div>
											</div>
										</div>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="height: 62px;"></div>
	</div>
</template>
<script src="https://yzf.qq.com/xv/web/static/chat_sdk/yzf_chat.min.js"></script>
<script>
import { WOW } from 'wowjs';
export default {
	props: ['isFixed'],
	mounted() {
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			var wow = new WOW({
				live: false,
				offset: 100
			});
			wow.init();
		});
		// this.kefu()
	},
	methods: {
		prev1(){
			this.$refs.carouse1.prev();
		},
		next1(){
			this.$refs.carouse1.next();
		},
		prev2(){
			this.$refs.carouse2.prev();
		},
		next2(){
			this.$refs.carouse2.next();
		},
		change(index) {
			this.activeBar = index;
		},
		toOpen() {
			this.$router.push('/freeTrial');
		},
		kefu() {
			// window.yzf.open();

			//window.yzf.close() 关闭1已打开的回话窗口
		}
	},

	data() {
		return {
			activeBar: 0,
			functionList: [
				{
					subTitle: '精细化营销管理子系统',
					imgUrl: require('@/assets/productAndservice/kernel1.png'),
					textList: ['客户、终端、产品管理', '人员、营销数据管理', '财务标准设定', '推广方案设定', '电子化协议']
				},
				{
					subTitle: '合规化业务采集子系统',
					imgUrl: require('@/assets/productAndservice/kernel2.png'),
					textList: ['推广任务规划', 'APP+小程序便捷记录行为', '内嵌定位签到系统', '一键汇总证据文件', '智能审计自检数据']
				},
				{
					subTitle: '费控化财务管理子系统',
					imgUrl: require('@/assets/productAndservice/kernel3.png'),
					textList: ['月度费用额度管理', '发票真伪便捷查验', '证据-发票强关联', '付款信息便捷导入', '自动形成费用台账']
				}
			],
			advantageList: [
				{
					IconUrl: require('@/assets/home/icon/lightspot1.png'),
					subTitle: '符合三级合规模式',
					text: '从药企到区域代理商到一线自然人的三级推广服务，实现药销通系统是业内最早实现三级合规的一体化系统。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot2.png'),
					subTitle: '契合公司现有业务规划及整体架构',
					text: '可在不改变公司原本宏观业务规划的基础上，直接进一步细化业务流程、规范业务环节。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot3.png'),
					subTitle: '业内最丰富的推广服务项目体系',
					text: '系统包含5大类协议、47种推广服务项目及合规模板。费用分解方式多元丰富，具备极大组合弹性。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot4.png'),
					subTitle: '行为痕迹轻松记录',
					text: '通过APP和微信端系统，固化服务行为要素傻瓜式、向导式的辅助一线代表记录日常服务的碎片化痕迹，形成可追溯的合规证据链。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot5.png'),
					subTitle: '服务成果图表化分析，提升服务专业度',
					text: '月底一键汇总服务成果，自动生成图表化分析报告，强化服务成果的技术含量，提升服务成果质量。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot6.png'),
					subTitle: '智能审计数据自检，节约审核人力成本',
					text: '对服务商形成的证据文件，按照合理性量化规则进行自动审核可提前规避70%-80%的文件问题，节约审核人员资源投入，降低合规审核成本。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot7.png'),
					subTitle: '多个工业主体一个账套实现，且系统用户数不受限，简化操作节约成本',
					text: '使用同一账户实现多个工业身份登录，节省账套切换时间成本;花一套的成本实现多套的价值，节约系统购买成本;系统用户数不受限。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot8.png'),
					subTitle: '电子签章实现无纸化办公，节约运营成本，简化业务流程',
					text: '免去传统方式往返邮寄的物料成本、等待包裹的时间成本及存储证据链的空间成本;无需邮寄，简化流程。'
				},
				{
					IconUrl: require('@/assets/home/icon/lightspot9.png'),
					subTitle: '工商金税系统集成、融合行业大数据、系统易用性高',
					text: '与国家企业信用、金税发票信息对接，直接获取工商、发票信息，系统录入操作简单便捷。'
				}
			],
			list: [
				{
					title: '行业合规转型背景',
					subTitle: '大环境下业内的普遍诉求',
					compliance1: require('@/assets/productAndservice/compliance1.png'),
					compliance2: require('@/assets/productAndservice/compliance2.png'),
					compliance3: require('@/assets/productAndservice/compliance3.png'),
					textList: [
						'医药行业是一个非常特殊的行业，其服务对象为人，涉及人的生命、健康和安全，所以医药行业面临更大的法律监管风险',
						'两票制、税制改革形势下，实现药品推广合规化，营销实务服务外包，符合财税要求。',
						'药品销售与服务推广分离。价值再定位，回归服务本质。做一个合法合规可持续的专业推广服务商。'
					]
				},
				{
					title: '核心功能',
					subTitle: '产品核心功能',
					textList: ['客户、终端、产品管理', '人员、营销数据管理', '财务标准设定', '推广方案设定', '电子化协议']
				},
				{
					title: '独特优势',
					subTitle: '功能亮点',
					textList: [
						'销售与推广分离的一体化业务财务转型',
						'精细效能化管控自营与服务商合规推广',
						'6大类60多项药械商务及推广服务项目',
						'服务预算与业务链审计确保“四流统一”',
						'电子化流程化集成化决策化云系统'
					]
				}
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.isFixed {
	position: fixed;
	top: 80px;
	z-index: 998;
}
.titleList {
	width: $global-content-width;
	justify-content: space-evenly;
	font-size: 24px;
	font-weight: 400;
	color: #333333;
	line-height: 33px;
	.item {
		width: 192px;
		height: 58px;
		justify-content: space-between;
		align-items: center;
	}
	.active-item {
		font-weight: 600;
		color: #2970ec;
	}
	.bar {
		width: 88px;
		height: 1px;
		background: transparent;
	}
	.active-bar {
		background-color: $global-default-primary;
	}
}
.bottom:before {
	content: '';
	display: table;
}
.bottom {
	width: 1309px;
	margin-top: 4px;
	height: 927px;
	// background:red;
	background-image: url('../../../assets/productAndservice/banner2.png');
	background-repeat: no-repeat;
	// box-shadow: 0px 6px 4px 0px #ecf1fa, -4px 0px 4px 0px rgba(236, 241, 250, 0.5);
	// border: 1px solid #ffffff;
	.subTitle {
		width: 100%;
		margin-top: 51px;
		text-align: center;
		font-size: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
	}
	.appealContent {
		justify-content: space-between;
		margin: 0 auto;
		// margin-top: 42px;
		// background-color: red;
		width: 1137px;
		height: 750px;
		// background-color: red;
		// background: $global-default-opacity-background;
		.item {
			position: relative;
			margin: 0 auto;
			width: 1063px;
			height: 176px;
			background: linear-gradient(180deg, #f7faff 0%, #ffffff 100%);
			box-shadow: 0px 6px 4px 0px #ecf1fa, -11px 0px 4px 0px rgba(236, 241, 250, 0.5);
		}
		.item1:before {
			content: '';
			display: table;
		}
		.item1 {
			// margin-top: 42px;
			.image {
				position: absolute;
				bottom: -13px;
				width: 257px;
				height: 156px;
			}
			.text {
				margin-top: 72px;
				margin-left: 277px;
				width: 683px;
				height: 56px;
				font-size: 16px;
				font-weight: 400;
				color: #333333;
				line-height: 28px;
			}
		}
		.item2:before {
			content: '';
			display: table;
		}
		.item2 {
			// margin-top: 118px;
			.image {
				position: absolute;
				top: -80px;
				right: 64px;
				width: 213px;
				height: 213px;
			}
			.text {
				margin-top: 77px;
				margin-left: 106px;
				width: 608px;
				height: 22px;
				font-size: 16px;
				font-family: Helvetica;
				color: #333333;
				line-height: 19px;
			}
		}
		.item3:before {
			content: '';
			display: table;
		}
		.item3 {
			// margin-top: 96px;
			.image {
				position: absolute;
				bottom: -61px;
				left: 16px;
				width: 204px;
				height: 186px;
			}
			.text {
				margin-top: 77px;
				margin-left: 261px;
				width: 608px;
				height: 22px;
				font-size: 16px;
				font-family: Helvetica;
				color: #333333;
				line-height: 19px;
			}
		}
	}
	.appealContent:before {
		content: '';
		display: table;
	}
	.el-carousel__arrow ::v-deep {
		width: 42px;
		height: 42px;
		background: #d3e2fd;
	}
	.shell {
		position: relative;
		width: 1137px;
		height: 820px;
		margin: 0 auto;
		margin-left: 90px;
		.arrow {
			text-align: center;
			position: absolute;
			width: 42px;
			height: 42px;
			background: rgba(211, 226, 253, 0.3);
			border-radius: 21px;
			color: white;
			font-size: 38px;
			line-height: 42px;
		}
		.arrow-left {
			left: -100px;
			top: 50%;
		}
		.arrow-right {
			right: -100px;
			top: 50%;
		}
	}
	.advantage {
		width: 1137px;
		height: 924px;
		// background: $global-default-opacity-background;
		margin: 0 auto;
		// margin-top: 42px;
		.list {
			width: 1072px;
			height: 702px;
			margin-top: 81px;
			margin-left: 31px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-content: flex-start;
		}
		.item {
			margin-bottom: 33px;
			width: 511px;
			height: 214px;
			background: linear-gradient(180deg, #f4f6f8 0%, #fefeff 100%);
			box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
			border-radius: 4px;
			border: 2px solid #ffffff;
			.line1 {
				align-items: center;
				.img {
					text-align: center;
					line-height: 55px;
					width: 46px;
					height: 46px;
					margin-top: 9px;
					margin-left: 30px;
				}
				.subTitle2 {
					display: flex;
					align-items: center;
					margin-top: 9px;
					margin-left: 19px;
					// width: 360px;
					height: 66px;
					width: 400px;
					font-size: 24px;
					font-weight: 600;
					color: #333333;
				}
			}
			.text {
				margin-top: 31px;
				margin-left: 28px;
				width: 450px;
				height: 44px;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				line-height: 22px;
			}
		}
	}
	.function {
		width: 1137px;
		height: 924px;
		// background: $global-default-opacity-background;
		margin: 0 auto;
		// margin-top: 42px;
		.left {
			margin-top: 206px;
			margin-left: 61px;
			width: 467px;
			height: 467px;
			line-height: 467px;
			text-align: center;
			font-size: 50px;
		}
		.right {
			margin-left: 55px;
			margin-top: 250px;
			.subTitle2 {
				text-align: left;
				font-size: 26px;
				font-weight: 600;
				color: #333333;
				margin-bottom: 43px;
			}
			.content2 {
				height: 25px;
				align-items: center;
				margin-bottom: 22px;
				.dot {
					margin-right: 16px;
					width: 8px;
					height: 8px;
					border-radius: 4px;
					background: linear-gradient(270deg, #99baff 0%, #2970ec 100%);
				}
				.text {
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 25px;
				}
			}
			.button {
				margin-top: 75px;
				.button1 {
					.el-button {
						width: 199px;
						height: 44px;
						border-radius: 4px;
					}
				}
				.button2 {
					margin-left: 22px;
					.el-button {
						width: 199px;
						height: 44px;
						background: transparent !important;
						border-radius: 4px;
						color: #2970ec !important;
						border: 1px solid #2970ec !important;
					}
				}
			}
		}
	}
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	margin-bottom: 103px;
	margin-top: 82px;
}
.introduce {
	margin-top: 105px;
	background: $global-default-opacity-background;
}
.content {
	margin: 0 auto;
	width: $global-content-width;
}
.content::before {
	content: '';
	display: table;
}
</style>
